module.exports = __webpack_public_path__ + "img/cv.6222fe3.webp";